<template>
  <div class="stages-tabs" :class="{'is-show': show}">
    <nav class="row no-gutters">
      <li class="col-4 stages-tabs--green" @click="goTo(1)"
          :class="{active: activeTab===1}">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
             width="26px" height="26px" viewBox="0 0 26 26" >
          <path fill-rule="evenodd"
                d="M12.595,0.529 C5.639,0.529 -0.000,6.167 -0.000,13.123 C-0.000,20.079 5.639,25.718 12.595,25.718 C19.550,25.718 25.189,20.079 25.189,13.123 C25.189,6.167 19.550,0.529 12.595,0.529 ZM6.897,21.925 L7.762,17.695 L7.773,17.625 C7.914,16.583 8.813,15.796 9.865,15.796 L10.493,15.796 C11.135,16.128 11.845,16.272 12.595,16.272 C13.344,16.272 14.054,16.128 14.697,15.796 L15.418,15.796 C16.470,15.796 17.369,16.582 17.510,17.625 L18.376,21.874 C16.717,22.974 14.730,23.619 12.595,23.619 C10.494,23.619 8.540,22.992 6.897,21.925 ZM12.595,14.173 C11.023,14.173 9.446,12.292 9.446,10.499 C9.446,8.813 10.909,7.351 12.595,7.351 C14.281,7.351 15.743,8.813 15.743,10.499 C15.743,12.292 14.166,14.173 12.595,14.173 ZM20.203,20.332 L19.585,17.307 C19.355,15.707 18.225,14.419 16.756,13.922 C17.379,12.987 17.842,11.636 17.842,10.499 C17.842,7.652 15.443,5.252 12.595,5.252 C9.747,5.252 7.347,7.652 7.347,10.499 C7.347,11.646 7.817,13.007 8.450,13.947 C7.019,14.463 5.925,15.735 5.698,17.307 L5.063,20.416 C3.232,18.526 2.099,15.956 2.099,13.123 C2.099,7.336 6.807,2.628 12.595,2.628 C18.382,2.628 23.090,7.336 23.090,13.123 C23.090,15.915 21.987,18.450 20.203,20.332 Z"/>
        </svg>
      </li>
      <li class="col-4 stages-tabs--cyan" @click="goTo(2)"
          :class="{active: activeTab===2}">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="31px" height="21px"
        >
          <path fill-rule="evenodd"
                d="M15.036,0.342 C6.926,0.342 -0.000,10.367 -0.000,10.367 C-0.000,10.367 6.922,20.391 15.036,20.391 C23.146,20.391 30.073,10.367 30.073,10.367 C30.073,10.367 23.151,0.342 15.036,0.342 ZM15.036,17.885 C10.357,17.885 5.553,13.296 3.132,10.367 C5.546,7.436 10.339,2.849 15.036,2.849 C19.716,2.849 24.520,7.437 26.940,10.367 C24.526,13.297 19.734,17.885 15.036,17.885 ZM20.048,10.367 C20.048,7.599 17.804,5.355 15.036,5.355 C12.268,5.355 10.024,7.599 10.024,10.367 C10.024,13.135 12.268,15.379 15.036,15.379 C17.804,15.379 20.048,13.135 20.048,10.367 M15.036,12.873 C13.501,12.873 12.530,11.902 12.530,10.367 C12.530,8.832 13.501,7.861 15.036,7.861 C16.572,7.861 17.542,8.832 17.542,10.367 C17.542,11.902 16.572,12.873 15.036,12.873 Z"/>
        </svg>
      </li>
      <li class="col-4 stages-tabs--blue" @click="goTo(3)"
          :class="{active: activeTab===3}">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="26px" height="26px">
          <path fill-rule="evenodd"
                d="M12.954,0.501 C5.990,0.501 0.345,6.146 0.345,13.110 C0.345,20.074 5.990,25.719 12.954,25.719 C19.918,25.719 25.563,20.074 25.563,13.110 C25.563,6.146 19.918,0.501 12.954,0.501 ZM12.954,23.617 C7.160,23.617 2.447,18.904 2.447,13.110 C2.447,7.316 7.160,2.602 12.954,2.602 C18.748,2.602 23.462,7.316 23.462,13.110 C23.462,18.904 18.748,23.617 12.954,23.617 ZM12.954,5.755 C12.030,5.755 11.378,6.533 11.378,7.331 C11.378,8.129 12.030,8.907 12.954,8.907 C13.878,8.907 14.530,8.192 14.530,7.331 C14.530,6.469 13.878,5.755 12.954,5.755 ZM11.904,20.465 L14.005,20.465 L14.005,11.008 L11.904,11.008 L11.904,20.465 Z"/>
        </svg>
      </li>
    </nav>
    <div class="stages-tabs__content">
      <icon-close @click="$emit('close')" class="icon-close"></icon-close>
      <stages-experts v-show="activeTab===1"></stages-experts>
      <stages-experience v-show="activeTab===2"></stages-experience>
      <stages-how-to v-show="activeTab===3"></stages-how-to>
    </div>
  </div>
</template>

<script>
  import { RwlHeading } from "@rawlplug/rawlplug-design-components-library"

  export default {
    name: "StagesTabs",
    props: {
      show: {
        type: Boolean,
        default: false
      },
      activeTab: {
        type: Number,
      }
    },
    methods: {
      goTo(id) {
        this.$emit('goTo', id)
      }
    },
  }
</script>

<style lang="scss" scoped>
  @mixin make-tab-with-color($color) {
    background-color: $color;
    cursor: pointer;
    fill: white;
    svg {
      margin: 5px 0 0 5px;
    }

    &::after {
      background-color: $color;
    }

    &.active {
      background-color: #fff;
      color: $color;
      fill: $color;

      &::after {
        display: block;
      }
    }
  }

  .icon-close {
    position: absolute;
    top: 65px;
    right: 25px;
    transform: scale(1.2);
    fill: #939598;
    transform-origin: center;
    transition: fill 0.3s ease-in-out, transform 0.3s ease-in-out 0s;
    cursor: pointer;

    &:hover {
      transform: rotate(90deg);
      fill: $color-rwl-red-100;
    }
  }

  .stages-tabs {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    transform: translateX(-100%);
    width: 100%;
    height: 100%;
    overflow: auto;
    z-index: 5;
    transition: transform 140ms ease-in-out;

    &.is-show {
      transform: translateX(0);
    }

    nav {
      float: unset;

      li {
        list-style-type: none;
        margin: 0;
        padding: $spacing-3;
        font-size: 1.5em;
        color: white;

        &:after {
          content: "";
          display: none;
          position: absolute;
          top: -2px;
          height: 2px;
          left: 0;
          right: 0;
          background-color: inherit;
        }

        &.stages-tabs--green {
          @include make-tab-with-color($color-rwl-green-100);
        }

        &.stages-tabs--cyan {
          @include make-tab-with-color($color-rwl-cyan-100);
        }

        &.stages-tabs--blue {
          @include make-tab-with-color($color-rwl-blue-100);
        }

        span {
          padding-left: 0.5em;
        }
      }
    }

    &__content {
      background-color: #fff;
      min-height: 100%;

      .rwl-heading {
        text-align: center;
      }
    }
  }

  @media (min-width: $breakpoint-md-min) {
    .stages-tabs {
      position: absolute;
      overflow: initial;
      transform: translateY(900px);
      transition: transform 500ms ease-in-out;

      &.is-show {
        transform: translateY(0);
      }
    }
  }
</style>
